import styles from './Nav.module.css'; //styles
import helpers from '../helpers.js';
import { useState, useContext, memo } from 'react';
import { UserContext } from "../UserContext.js";
import { resolveApiBaseUrl } from '../services/apiBaseUrl.js';
import Icon from './Icon.js';

import logo from '../assets/images/bbbLogoWhiteTransparentNoText.png';
/*
    Navbar
        props:
            checked: boolean, sets checkbox status (checked, unchecked)
            onPress: function, action carried out when checked/unchecked
            label: str, label
            inverted: bool, if true sets label before checkbox 
*/
const Nav = (props) => {
    // const {user, setUser} = useContext(UserContext);
    const [currentScreen, setCurrentScreen] = useState(props.currentScreen);

    const API_URL = resolveApiBaseUrl();

    const changeScreens = (screen) => {
        setCurrentScreen(screen)
        props.goToScreen("/" + screen);
        console.log("HERE")
        //props.navigate
    }

    const openDocs = async () => {
        const token = localStorage.getItem("token");
        
        if (!token) {
            alert("Please log in to access documentation");
            return;
        }

        try {
            const response = await fetch(`${API_URL}/docs/bootstrap`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                credentials: "include",
            });

            if (!response.ok) {
                if (response.status === 403) {
                    alert("Admin access required to view documentation");
                } else {
                    alert("Failed to prepare documentation session. Please try again.");
                }
                return;
            }

            const docsUrl = `${API_URL.replace(/\/$/, "")}/docs/`;
            window.open(docsUrl, "_blank", "noopener,noreferrer");
        } catch (error) {
            console.error("Error loading documentation:", error);
            alert("Failed to load documentation. Please try again.");
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        // The signed-out user object that used to be built here went nowhere:
        // setUser is commented out (see the UserContext import above), so it was
        // a third copy of the backend-URL rule with no reader. Removed rather
        // than migrated. Restoring the reset means restoring setUser too.
        props.goToScreen("/login");
    };
    // useEffect(() => { OTHER COLORS?
        
    // }, [props.color])

    

    // <li className={helpers.clx(styles.menuItem, currentScreen === "settings" ? styles.menuItemSelected : "")} onClick={() => changeScreens("settings")}>
    //                 <div className={styles.navIcon}>
    //                     wrench
    //                 </div>
    //                 Settings
    //                 <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "settings" ? styles.selectedTrapeziumSelected : "")}>
    //                     <div className={helpers.clx(styles.triangleHidden, currentScreen === "settings" ? styles.triangle : "")}/>
    //                 </div>
    //             </li>

    return(
        <div className={styles.mainContainer}>
            <img src={logo} className={styles.bbbLogo}/>
            <ul className={styles.menuItems}>
                {/* <li className={helpers.clx(styles.menuItem, currentScreen === "home" ? styles.menuItemSelected : "")} onClick={() => changeScreens("home")}>
                    <div className={styles.navIcon}>
                        home
                    </div>
                    Home
                    <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "home" ? styles.selectedTrapeziumSelected : "")}>
                        <div className={helpers.clx(styles.triangleHidden, currentScreen === "home" ? styles.triangle : "")}/>
                    </div>
                </li>
                <li className={helpers.clx(styles.menuItem, currentScreen === "analytics" ? styles.menuItemSelected : "")} onClick={() => changeScreens("analytics")}>
                    <div className={styles.navIcon}>
                        chart-line
                    </div>
                    Analytics
                    <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "analytics" ? styles.selectedTrapeziumSelected : "")}>
                        <div className={helpers.clx(styles.triangleHidden, currentScreen === "analytics" ? styles.triangle : "")}/>
                    </div>
                </li> */}
                {props.isAdmin ? 
                    <>
                        <li className={helpers.clx(styles.menuItem, currentScreen === "admin/timeline" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/timeline")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaCalendarAlt" size={16} />
                            </div>
                            Timeline
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/timeline" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/timeline" ? styles.triangle : "")}/>
                            </div>
                        </li>
                        <li className={helpers.clx(styles.menuItem, currentScreen === "admin/farmers" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/farmers")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaTractor" size={16} />
                            </div>
                            Farmers
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/farmers" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/farmers" ? styles.triangle : "")}/>
                            </div>
                        </li>
                        
                        {/* <li className={helpers.clx(styles.disabledAdmin, styles.menuItem, currentScreen === "orders" ? styles.menuItemSelected : "")} onClick={() => changeScreens("orders")}>
                            <div className={styles.navIcon}>
                                map
                            </div>
                            Map
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "orders" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "orders" ? styles.triangle : "")}/>
                            </div>
                        </li> */}
                        <li className={helpers.clx( styles.menuItem, currentScreen === "admin/inventory" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/inventory")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaWarehouse" size={16} />
                            </div>
                            Inventory
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/inventory" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/inventory" ? styles.triangle : "")}/>
                            </div>
                        </li>   
                        {/* <li className={helpers.clx(styles.disabledAdmin, styles.menuItem, currentScreen === "settings" ? styles.menuItemSelected : "")} onClick={() => changeScreens("orders")}>
                            <div className={styles.navIcon}>
                            truck-loading
                            </div>
                            Orders
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "settings" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "settings" ? styles.triangle : "")}/>
                            </div>
                        </li>
                        <li className={helpers.clx(styles.disabledAdmin, styles.menuItem, currentScreen === "settings" ? styles.menuItemSelected : "")} onClick={() => changeScreens("settings")}>
                            <div className={styles.navIcon}>
                            truck
                            </div>
                            Deliveries
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "settings" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "settings" ? styles.triangle : "")}/>
                            </div>
                        </li> */}
                        <li className={helpers.clx(styles.menuItem, currentScreen === "admin/charcodes" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/charcodes")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaQrcode" size={16} />
                            </div>
                            Charcodes
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/charcodes" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/charcodes" ? styles.triangle : "")}/>
                            </div>
                        </li>     
                        {/* <li className={helpers.clx(styles.disabledAdmin, styles.menuItem, currentScreen === "admin/team" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/team")}>
                            <div className={styles.navIcon}>
                                 users
                            </div>
                            Team
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/team" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/team" ? styles.triangle : "")}/>
                            </div>
                        </li>      */}
                        <li className={helpers.clx(styles.menuItem, currentScreen === "admin/help-center" ? styles.menuItemSelected : "")} onClick={() => changeScreens("admin/help-center")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaHeadset" size={16} />
                            </div>
                            Help Center
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "admin/help-center" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "admin/help-center" ? styles.triangle : "")}/>
                            </div>
                        </li>
                                            
                    </>
                  :
                    <>
                        <li className={helpers.clx(styles.menuItem, currentScreen === "subscription" ? styles.menuItemSelected : "")} onClick={() => changeScreens("subscription")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaUser" size={16} />
                            </div>
                            My Biochar
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "subscription" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "subscription" ? styles.triangle : "")}/>
                            </div>
                        </li>
                      
                        <li className={helpers.clx(styles.menuItem, currentScreen === "zones" ? styles.menuItemSelected : "")} onClick={() => changeScreens("zones")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaMapMarkedAlt" size={16} />
                            </div>
                            Biochar Plan
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "zones" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "zones" ? styles.triangle : "")}/>
                            </div>
                        </li>
                          <li className={helpers.clx(styles.menuItem, currentScreen === "orders" ? styles.menuItemSelected : "")} onClick={() => changeScreens("orders")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaTruck" size={16} />
                            </div>
                            Deliveries
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "orders" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "orders" ? styles.triangle : "")}/>
                            </div>
                        </li>
                        <li className={helpers.clx(styles.menuItem, currentScreen === "invoices" ? styles.menuItemSelected : "")} onClick={() => changeScreens("invoices")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaReceipt" size={16} />
                            </div>
                            Invoices
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "invoices" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "invoices" ? styles.triangle : "")}/>
                            </div>
                        </li>
                        {/* <li className={helpers.clx(styles.menuItem, currentScreen === "settings" ? styles.menuItemSelected : "")} onClick={() => changeScreens("settings")}>
                            <div className={styles.navIcon}>
                            wrench
                            </div>
                            Settings
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "settings" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "settings" ? styles.triangle : "")}/>
                            </div>
                        </li> */}
                        <li className={helpers.clx(styles.menuItem, currentScreen === "support" ? styles.menuItemSelected : "")} onClick={() => changeScreens("support")}>
                            <div className={styles.navIcon}>
                                <Icon name="FaQuestionCircle" size={16} />
                            </div>
                            Support
                            <div className={helpers.clx(styles.selectedTrapezium, currentScreen === "support" ? styles.selectedTrapeziumSelected : "")}>
                                <div className={helpers.clx(styles.triangleHidden, currentScreen === "support" ? styles.triangle : "")}/>
                            </div>
                        </li>
                    </>
                }
                
            </ul>
            <div className={styles.footerActions}>
                {props.isAdmin && (
                    <div onClick={openDocs} className={styles.footerAction}>
                        Doc <span className={styles.logoutIcon}><Icon name="FaBook" size={16} /></span>
                    </div>
                )}
                <div onClick={() => logout()} className={styles.footerAction}>
                    Logout <span className={styles.logoutIcon}><Icon name="FaSignOutAlt" size={16} /></span>
                </div>
            </div>
            <div className={styles.bbbNavFooter}>
                BLACK BULL BIOCHAR
            </div>
        </div>
    )
}

Nav.defaultProps = {
    checked: false,
    isAdmin: false
  };

export default memo(Nav);